// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { JenisLembagaDetailResponse } from "./types";

import * as jenisLembagaActions from "./jenisLembaga.actions";

export function* getDetailJenisLembaga(
  action: ReturnType<typeof jenisLembagaActions.getDetailJenisLembagaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = `${BASE_URL}jenis-lembaga/${action.payload.id}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: JenisLembagaDetailResponse = yield call(result.json.bind(result));
      yield put(jenisLembagaActions.getDetailJenisLembagaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(jenisLembagaActions.getDetailJenisLembagaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(jenisLembagaActions.getDetailJenisLembagaAsync.failure(parsed));
  }
}

export default function* jenisLembagaSagaGetDetailJenisLembaga() {
  yield takeEvery(jenisLembagaActions.getDetailJenisLembagaAsync.request, getDetailJenisLembaga);
}
